import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import {
  CardAccent,
  CardComponent,
  CardDescriptionComponent,
  CardHeaderComponent,
  CardTitleComponent,
  CardTrailingComponent,
  FormatPipe,
  IconComponent,
} from '@softline/ui-core';
import { PersonalUebersicht } from '../../types/abteilung';

const STATUS_ACCENT: Record<string, CardAccent> = { A: 'success', E: 'warning', U: 'danger' };

@Component({
  selector: 'soft-mitarbeiter-card',
  imports: [
    CardComponent,
    CardDescriptionComponent,
    CardHeaderComponent,
    CardTitleComponent,
    CardTrailingComponent,
    FormatPipe,
    IconComponent,
  ],
  templateUrl: './mitarbeiter-card.component.html',
  styleUrl: './mitarbeiter-card.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MitarbeiterCardComponent {
  readonly mitarbeiter = input.required<PersonalUebersicht>();
  readonly selected = input(false);
  readonly mode = input<'selection' | 'display'>('display');
  readonly tapped = output<void>();

  protected readonly accent = computed<CardAccent>(
    () => STATUS_ACCENT[this.mitarbeiter().status ?? ''] ?? 'none'
  );
  protected readonly isSelected = computed(() => this.mode() === 'selection' && this.selected());
  protected readonly isOnVacation = computed(
    () => this.mitarbeiter().abwesenheit?.bezeichnung === 'Urlaub'
  );
  protected readonly hasDetails = computed(() => {
    const person = this.mitarbeiter();
    return (
      !!person.letzterStempel ||
      !!person.aktuellerTermin ||
      !!person.aktuellerDpEintrag ||
      this.isOnVacation()
    );
  });
}
